import { takeLatest } from 'redux-saga/effects';
import { registerSaga, loginSaga } from './authenticationSaga';
import { 
  donorSaga, 
  updateDonorSaga,
  selfserviceDonorSaga, 
  notifyDonorsSaga, 
  fetchAllDonorsSaga,
  fetchDonorByPhoneSaga,
  addVolunteerDonorSaga,
  addActualDonorSaga,
  deleteVolunteerDonorSaga,
  importDonorsSaga,
  sendOTPDonorSaga
} from './donorSaga';
import { patientSaga, 
  fetchPatientSaga, 
  fetchAllPatientsSaga,
  fetchPatientsByPatientNameSaga,
  fetchPatientByPhoneSaga,
  fetchPatientsByAttenderNameSaga,
  verifyPatientSaga, 
  matchingDonorsSaga,
  matchDonorPhoneSaga,
  saveMatchingDonorSaga,
  updatePatientSaga} from './patientSaga';
import { fetchLocalitySaga,fetchDistrictSaga } from './localitySaga';  
import { 
  updateProfileSaga,
  changePwdSaga,
  resetPwdSaga,
  forgotPwdSaga,
  deregisterAdminSaga,
  fetchAllAdminSaga,
  saveSecondaryDistrictsSaga
} from './adminSaga';

import * as types from './../actions';

export function* watchUserAuthentication() {
  yield takeLatest(types.REGISTER_USER, registerSaga);
  yield takeLatest(types.LOGIN_USER, loginSaga);
}

export function* watchDonor() {
  yield takeLatest(types.DONOR_SUBMIT, donorSaga);
}

export default function* watch() {
  yield takeLatest(types.PATIENT_SUBMIT, patientSaga);
  yield takeLatest(types.PATIENT_UPDATE, updatePatientSaga);
  yield takeLatest(types.ALL_PATIENT_FETCH, fetchAllPatientsSaga);
  yield takeLatest(types.PATIENT_FETCH, fetchPatientSaga);
  yield takeLatest(types.FETCH_BY_PATIENT_NAME, fetchPatientsByPatientNameSaga);
  yield takeLatest(types.FETCH_BY_ATTENDER_NAME, fetchPatientsByAttenderNameSaga);
  yield takeLatest(types.FETCH_BY_PATIENT_PHONE, fetchPatientByPhoneSaga);
  yield takeLatest(types.PATIENT_VERIFY, verifyPatientSaga);
  yield takeLatest(types.MATCH_DONORS, matchingDonorsSaga);
  yield takeLatest(types.MATCH_DONOR_PHONE, matchDonorPhoneSaga);
  yield takeLatest(types.SAVE_MATCHING_DONOR, saveMatchingDonorSaga);
  yield takeLatest(types.DONOR_SUBMIT, donorSaga);
  yield takeLatest(types.DONOR_UPDATE, updateDonorSaga);
  yield takeLatest(types.DONOR_SELFSERVICE, selfserviceDonorSaga);
  yield takeLatest(types.NOTIFY_DONORS, notifyDonorsSaga);
  yield takeLatest(types.ALL_DONORS_FETCH, fetchAllDonorsSaga);
  yield takeLatest(types.DONOR_FETCHBYPHONE, fetchDonorByPhoneSaga);
  yield takeLatest(types.ADD_VOLUNTEER_DONOR, addVolunteerDonorSaga);
  yield takeLatest(types.ADD_ACTUAL_DONOR, addActualDonorSaga);
  yield takeLatest(types.DELETE_VOLUNTEER_DONOR, deleteVolunteerDonorSaga);
  yield takeLatest(types.IMPORT_DONORS, importDonorsSaga);
  yield takeLatest(types.SEND_OTP_DONOR, sendOTPDonorSaga);
  yield takeLatest(types.LOGIN_USER, loginSaga);
  yield takeLatest(types.REGISTER_USER, registerSaga);
  yield takeLatest(types.UPDATE_PROFILE, updateProfileSaga);
  yield takeLatest(types.SAVE_SECONDARY_DISTRICTS, saveSecondaryDistrictsSaga);
  yield takeLatest(types.CHANGE_PASSWORD, changePwdSaga);
  yield takeLatest(types.DEREGISTER_ADMIN, deregisterAdminSaga);
  yield takeLatest(types.RESET_PASSWORD, resetPwdSaga);
  yield takeLatest(types.FORGOT_PASSWORD, forgotPwdSaga);
  yield takeLatest(types.FETCH_ALL_ADMIN, fetchAllAdminSaga);
  yield takeLatest(types.LOCALITY_FETCH, fetchLocalitySaga);
  yield takeLatest(types.DISTRICT_FETCH, fetchDistrictSaga);
}